import { ServicePlanInput } from '@infura/packages.api'
import { ServiceAddon, ServiceTier, V1Service } from '@infura/packages.uks'

export interface Addon {
  type: ServiceAddon
  quantity: number
  selected: boolean
}

export type KSService = V1Service

/**
 * Returns a service_plan input object
 *
 * @param {ServiceTier} newTier
 * @param {number} reqAddonQty new traffic_addon or credits_addon quantity
 * @return {ServicePlanInput} the service_plan input
 */
export function buildServicePlanInput({
  newTier,
  reqAddonQty,
  throughputAddonEnabled
}: {
  newTier: ServiceTier
  reqAddonQty: number
  throughputAddonEnabled: boolean
}): ServicePlanInput {
  const newServicePlan: ServicePlanInput = {
    addons: {},
    tier: newTier
  }

  if (reqAddonQty !== undefined) {
    newServicePlan.addons[ServiceAddon.TRAFFIC_ADDON] = reqAddonQty
  }

  newServicePlan.addons[ServiceAddon.THROUGHPUT_ADDON] = throughputAddonEnabled

  return newServicePlan
}
